// Список незавершённых упражнений студента: загружает историю, дедуплицирует по exercise_id и рендерит карточки.

import { useEffect, useState } from 'react';
import { Spinner, Alert, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getStudentHistory } from '../../../api/studentApi';
import IncompleteExerciseCard from './IncompleteExerciseCard';

/**
 * Загружает историю студента, фильтрует незавершённые упражнения (status === 0),
 * дедуплицирует по exercise_id и рендерит список карточек.
 */
export default function IncompleteExerciseList() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [items, setItems] = useState([]);

  useEffect(() => {
    setLoading(true);
    setError(null);

    getStudentHistory(50, 0)
      .then((res) => {
        const data = res.data ?? [];

        // Фильтруем только незавершённые (status === 0)
        const incomplete = data.filter((h) => h.status === 0);

        // Дедуплицируем по exercise_id — берём первый (самый свежий)
        const seen = new Set();
        const unique = incomplete.filter((h) => {
          if (seen.has(h.exercise_id)) return false;
          seen.add(h.exercise_id);
          return true;
        });

        setItems(unique);
      })
      .catch((err) => {
        console.error('Ошибка загрузки истории:', err);
        setError('Не удалось загрузить незавершённые упражнения. Попробуйте обновить страницу.');
      })
      .finally(() => setLoading(false));
  }, []);

  const onContinue = (exerciseId, variantId) => {
    navigate('/student/exercises/exercise', {
      state: { exerciseId, ...(variantId ? { variantId } : {}) },
    });
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center py-5">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  if (error) {
    return (
      <Alert variant="danger" className="border-0" style={{ borderRadius: '0.875rem' }}>
        {error}
      </Alert>
    );
  }

  if (items.length === 0) {
    return (
      <Card
        className="border-0 text-center py-5"
        style={{
          borderRadius: '0.875rem',
          boxShadow: '0 1px 6px rgba(0,0,0,0.07)',
          background: '#fff',
        }}
      >
        <Card.Body>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
          <h6
            className="fw-semibold mb-1"
            style={{ color: '#1e2a4a' }}
          >
            Все упражнения завершены!
          </h6>
          <p className="text-muted mb-0" style={{ fontSize: '0.875rem' }}>
            Нет незавершённых упражнений
          </p>
        </Card.Body>
      </Card>
    );
  }

  return (
    <div className="d-flex flex-column gap-3">
      {items.map((item) => (
        <IncompleteExerciseCard
          key={item.exercise_id}
          item={item}
          onContinue={onContinue}
        />
      ))}
    </div>
  );
}
